import MultiplePlaylistsShareModal from './MultiplePlaylistsShareTooltip'

export default MultiplePlaylistsShareModal
// eslint-disable-next-line import/export
export * from './MultiplePlaylistsShareTooltip'
